// /**
//  * Wishlist Toast Popup (with Add / Remove detection) — DEBUGGED
//  * -------------------------------------------------------------------------
//  * Shows a 3-second popup with the product image, title and price when a
//  * wishlist button is clicked, and detects whether the click ADDED or
//  * REMOVED the product.
//  *
//  * FIXES OVER THE ORIGINAL VERSION
//  * -------------------------------------------------------------------------
//  * 1. SCOPE (biggest bug): the old code triggered on ANY click inside an
//  *    element with [data-product-handle]. That attribute usually sits on the
//  *    whole product card, so clicking the title, image or "Add to cart" also
//  *    fired the toast. We now require the click to land on an actual wishlist
//  *    trigger (see WISHLIST_SELECTOR) and only then look upward for the card.
//  *
//  * 2. TOGGLE DETECTION: the old logic looked for the substring "remove"
//  *    anywhere in the label/class. Many wishlist apps keep a hidden
//  *    "Remove from wishlist" span (or a permanent .wishlist-remove class)
//  *    in the DOM at all times, so "remove" was present both before AND after
//  *    the click, and the result was always "add". We now compute a boolean
//  *    "is in wishlist" state (aria-pressed > state classes > label text) and
//  *    compare before vs after.
//  *
//  * 3. RE-RENDER: the old code observed the button element itself. Apps that
//  *    replace the button on click detached that node, so no mutations ever
//  *    fired and the 1200ms fallback reported a wrong "add". We now observe
//  *    the surrounding container with subtree:true and re-query the button on
//  *    every mutation, so replacement is handled.
//  *
//  * 4. BROKEN IMAGE: img.src = '' made the browser request the current page
//  *    URL and render a broken-image icon. The image is now hidden instead.
//  *
//  * 5. GUARDS: e.target may not be an Element (TypeError on .closest), and
//  *    className on an SVG node is an SVGAnimatedString, not a string.
//  *
//  * 6. PERFORMANCE: product JSON is cached, so repeated clicks on the same
//  *    product don't re-fetch. In-flight requests are de-duplicated too.
//  *
//  * 7. ACCESSIBILITY: the toast now uses role="status" + aria-live="polite"
//  *    so screen readers announce it. Respects prefers-reduced-motion.
//  *
//  * 8. STACKING: a new click cancels the previous pending watcher, so two
//  *    fast clicks can't produce two conflicting toasts.
//  *
//  * Usage:
//  * 1) Save in your theme's assets folder as wishlist-toast.js
//  * 2) In theme.liquid, right before </body>:
//  *    <script src="{{ 'wishlist-toast.js' | asset_url }}" defer></script>
//  */
// (function () {
//   'use strict';

//   /* ---------------------------------------------------------------------
//    * CONFIG — adjust this to match your wishlist app's markup.
//    * Add whatever selector your wishlist button actually uses.
//    * ------------------------------------------------------------------- */
//   var WISHLIST_SELECTOR = [
//     '[data-wishlist-button]',
//     '[data-wishlist]',
//     '.wishlist-button',
//     '.wishlist-btn',
//     '.js-wishlist',
//     '.wk-button',            // common app prefixes
//     '.swym-button',
//     '[class*="wishlist"]'    // broad fallback — remove if it over-matches
//   ].join(',');

//   var CARD_SELECTOR = '[data-product-handle]';
//   var TOAST_MS = 3000;
//   var DETECT_TIMEOUT_MS = 2500;   // was 1200 — slow apps were being cut off

//   var hideTimer = null;
//   var activeWatcher = null;       // cancels a previous pending watcher
//   var productCache = Object.create(null);

//   /* ---------------------------------------------------------------------
//    * DOM helpers
//    * ------------------------------------------------------------------- */

//   // SVG elements return an SVGAnimatedString from .className, not a string.
//   function classString(el) {
//     if (!el) return '';
//     var c = el.className;
//     if (c && typeof c === 'object' && 'baseVal' in c) return c.baseVal;
//     return typeof c === 'string' ? c : '';
//   }

//   function labelString(el) {
//     if (!el) return '';
//     return (
//       (el.getAttribute('aria-label') || '') + ' ' +
//       (el.getAttribute('title') || '') + ' ' +
//       (el.textContent || '')
//     );
//   }

//   /**
//    * Best-effort guess at "is this product currently in the wishlist?"
//    * Checked in order of reliability.
//    */
//   function isInWishlist(button, card) {
//     // 1. aria-pressed is the most reliable signal when present.
//     var pressed = (button.getAttribute('aria-pressed') || '').toLowerCase();
//     if (pressed === 'true') return true;
//     if (pressed === 'false') return false;

//     // 2. State classes on the button or the card.
//     var cls = (classString(button) + ' ' + classString(card)).toLowerCase();
//     if (/(^|[\s_-])(is-)?(active|added|selected|checked|filled|liked|wishlisted|in-wishlist)([\s_-]|$)/.test(cls)) {
//       return true;
//     }

//     // 3. Visible label text. Only trusted as a last resort, because some
//     //    apps keep BOTH labels in the DOM and just toggle visibility.
//     var visibleText = '';
//     var nodes = button.querySelectorAll('*');
//     if (nodes.length) {
//       for (var i = 0; i < nodes.length; i++) {
//         var n = nodes[i];
//         if (n.offsetParent === null && n.getAttribute('aria-hidden') !== 'false') continue;
//         visibleText += ' ' + (n.getAttribute('aria-label') || '') + ' ' + (n.textContent || '');
//       }
//     }
//     if (!visibleText.trim()) visibleText = labelString(button);

//     return /remove|added|saved|in\s*wishlist/i.test(visibleText);
//   }

//   /* ---------------------------------------------------------------------
//    * Toast UI
//    * ------------------------------------------------------------------- */

//   function createToast() {
//     var existing = document.getElementById('wishlist-toast');
//     if (existing) return existing;

//     var style = document.createElement('style');
//     style.id = 'wishlist-toast-styles';
//     style.textContent =
//       '#wishlist-toast{position:fixed;top:240px;right:24px;display:flex;' +
//       'align-items:center;gap:12px;background:#fff;color:#111;border-radius:10px;' +
//       'box-shadow:0 8px 24px rgba(0,0,0,0.15);padding:12px 16px;max-width:320px;' +
//       'z-index:99999;opacity:0;transform:translateY(20px);' +
//       'transition:opacity .3s ease,transform .3s ease;pointer-events:none;font-family:inherit;}' +
//       '#wishlist-toast.show{opacity:1;transform:translateY(0);}' +
//       '#wishlist-toast img{width:48px;height:48px;object-fit:cover;border-radius:6px;flex-shrink:0;}' +
//       '#wishlist-toast img[hidden]{display:none;}' +
//       '#wishlist-toast .wt-text{display:flex;flex-direction:column;overflow:hidden;}' +
//       '#wishlist-toast .wt-status{font-size:12px;font-weight:600;margin-bottom:2px;}' +
//       '#wishlist-toast.wt-added .wt-status{color:#16a34a;}' +
//       '#wishlist-toast.wt-removed .wt-status{color:#6b7280;}' +
//       '#wishlist-toast .wt-title{font-size:13px;font-weight:500;white-space:nowrap;' +
//       'overflow:hidden;text-overflow:ellipsis;}' +
//       '#wishlist-toast .wt-price{font-size:12px;color:#666;}' +
//       '@media (prefers-reduced-motion: reduce){' +
//       '#wishlist-toast{transition:opacity .01ms;transform:none;}' +
//       '#wishlist-toast.show{transform:none;}}';
//     document.head.appendChild(style);

//     var toast = document.createElement('div');
//     toast.id = 'wishlist-toast';
//     // a11y: announce without stealing focus
//     toast.setAttribute('role', 'status');
//     toast.setAttribute('aria-live', 'polite');
//     toast.innerHTML =
//       '<img id="wt-img" src="" alt="" hidden>' +
//       '<div class="wt-text">' +
//       '<span class="wt-status" id="wt-status"></span>' +
//       '<span class="wt-title" id="wt-title"></span>' +
//       '<span class="wt-price" id="wt-price"></span>' +
//       '</div>';
//     document.body.appendChild(toast);
//     return toast;
//   }

//   function formatMoney(cents) {
//     cents = cents || 0;
//     if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
//       var fmt =
//         (window.theme && window.theme.moneyFormat) ||
//         (window.Shopify && window.Shopify.money_format) ||
//         null;
//       if (fmt) {
//         try {
//           return window.Shopify.formatMoney(cents, fmt);
//         } catch (e) { /* fall through to manual format */ }
//       }
//     }
//     var currency =
//       (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
//     return (currency ? currency + ' ' : '') + (cents / 100).toFixed(2);
//   }

//   function showToast(product, variant, action) {
//     var toast = createToast();
//     var img = document.getElementById('wt-img');
//     var title = document.getElementById('wt-title');
//     var price = document.getElementById('wt-price');
//     var status = document.getElementById('wt-status');

//     var imageUrl =
//       (variant && variant.featured_image && variant.featured_image.src) ||
//       product.featured_image ||
//       (product.images && product.images[0]) ||
//       '';

//     // FIX: never set src to '' — that requests the current page URL and
//     // renders a broken-image icon. Hide the element instead.
//     if (imageUrl) {
//       img.src = imageUrl;
//       img.alt = product.title || '';
//       img.hidden = false;
//     } else {
//       img.removeAttribute('src');
//       img.alt = '';
//       img.hidden = true;
//     }

//     title.textContent = product.title || '';
//     price.textContent = formatMoney(variant ? variant.price : product.price);

//     toast.classList.remove('wt-added', 'wt-removed');
//     if (action === 'remove') {
//       status.textContent = '\u2717 Removed from wishlist';
//       toast.classList.add('wt-removed');
//     } else {
//       status.textContent = '\u2713 Added to wishlist';
//       toast.classList.add('wt-added');
//     }

//     clearTimeout(hideTimer);
//     // Force a reflow so the transition replays if the toast is already shown.
//     void toast.offsetWidth;
//     toast.classList.add('show');
//     hideTimer = setTimeout(function () {
//       toast.classList.remove('show');
//     }, TOAST_MS);
//   }

//   /* ---------------------------------------------------------------------
//    * Product data (cached + de-duplicated)
//    * ------------------------------------------------------------------- */

//   function getProduct(handle) {
//     if (productCache[handle]) return productCache[handle];

//     var promise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
//       credentials: 'same-origin'
//     })
//       .then(function (res) {
//         if (!res.ok) throw new Error('HTTP ' + res.status + ' for ' + handle);
//         return res.json();
//       })
//       .catch(function (err) {
//         // Don't cache failures — allow a retry on the next click.
//         delete productCache[handle];
//         throw err;
//       });

//     productCache[handle] = promise;
//     return promise;
//   }

//   /* ---------------------------------------------------------------------
//    * Toggle watcher
//    * ------------------------------------------------------------------- */

//   /**
//    * Watches the CARD (not the button) so that apps which replace the button
//    * element on click are still detected. Re-queries the button each time.
//    */
//   function watchForToggle(card, buttonSelector, wasInWishlist, callback) {
//     var done = false;
//     var observer = null;
//     var timeoutId = null;

//     function finish(action) {
//       if (done) return;
//       done = true;
//       if (observer) observer.disconnect();
//       clearTimeout(timeoutId);
//       if (activeWatcher === handle) activeWatcher = null;
//       callback(action);
//     }

//     var handle = {
//       cancel: function () {
//         if (done) return;
//         done = true;
//         if (observer) observer.disconnect();
//         clearTimeout(timeoutId);
//       }
//     };

//     observer = new MutationObserver(function () {
//       if (done) return;

//       // Re-query: the original button may have been replaced entirely.
//       var current = card.querySelector(buttonSelector) || card;
//       var nowInWishlist = isInWishlist(current, card);

//       if (nowInWishlist === wasInWishlist) return;   // no state change yet
//       finish(nowInWishlist ? 'add' : 'remove');
//     });

//     observer.observe(card, {
//       attributes: true,
//       childList: true,
//       subtree: true,
//       characterData: true
//     });

//     timeoutId = setTimeout(function () {
//       // Couldn't detect a change in time. Assume the opposite of the
//       // previous state — that's the likely outcome of a toggle click, and
//       // it's a better guess than always saying "add".
//       finish(wasInWishlist ? 'remove' : 'add');
//     }, DETECT_TIMEOUT_MS);

//     return handle;
//   }

//   /* ---------------------------------------------------------------------
//    * Click handler (capture phase — runs before the app's own handler)
//    * ------------------------------------------------------------------- */

//   document.addEventListener('click', function (e) {
//     // FIX: e.target isn't guaranteed to be an Element.
//     var target = e.target;
//     if (!target || typeof target.closest !== 'function') return;

//     // FIX (main bug): require an actual wishlist trigger, not just any
//     // click inside the product card.
//     var button = target.closest(WISHLIST_SELECTOR);
//     if (!button) return;

//     var card = button.closest(CARD_SELECTOR) || target.closest(CARD_SELECTOR);
//     if (!card) return;

//     var handleAttr = card.getAttribute('data-product-handle') ||
//                      button.getAttribute('data-product-handle');
//     if (!handleAttr) return;

//     var variantId = card.getAttribute('data-variant-id') ||
//                     button.getAttribute('data-variant-id');

//     // Cancel any watcher still pending from a previous fast click.
//     if (activeWatcher) activeWatcher.cancel();

//     var wasInWishlist = isInWishlist(button, card);

//     activeWatcher = watchForToggle(card, WISHLIST_SELECTOR, wasInWishlist, function (action) {
//       getProduct(handleAttr)
//         .then(function (product) {
//           var variant = null;
//           if (variantId && product.variants) {
//             for (var i = 0; i < product.variants.length; i++) {
//               if (String(product.variants[i].id) === String(variantId)) {
//                 variant = product.variants[i];
//                 break;
//               }
//             }
//           }
//           if (!variant && product.variants && product.variants.length) {
//             variant = product.variants[0];
//           }
//           showToast(product, variant, action);
//         })
//         .catch(function (err) {
//           console.error('[wishlist-toast] product fetch failed:', err);
//         });
//     });
//   }, true);
// })();



/**
 * Wishlist Toast Popup (with Add / Remove detection) — DEBUGGED
 * -------------------------------------------------------------------------
 * Shows a 3-second popup with the product image, title and price when a
 * wishlist button is clicked, and detects whether the click ADDED or
 * REMOVED the product.
 *
 * FIXES OVER THE ORIGINAL VERSION
 * -------------------------------------------------------------------------
 * 1. SCOPE (biggest bug): the old code triggered on ANY click inside an
 *    element with [data-product-handle]. That attribute usually sits on the
 *    whole product card, so clicking the title, image or "Add to cart" also
 *    fired the toast. We now require the click to land on an actual wishlist
 *    trigger (see WISHLIST_SELECTOR) and only then look upward for the card.
 *
 * 2. TOGGLE DETECTION: the old logic looked for the substring "remove"
 *    anywhere in the label/class. Many wishlist apps keep a hidden
 *    "Remove from wishlist" span (or a permanent .wishlist-remove class)
 *    in the DOM at all times, so "remove" was present both before AND after
 *    the click, and the result was always "add". We now compute a boolean
 *    "is in wishlist" state (aria-pressed > state classes > label text) and
 *    compare before vs after.
 *
 * 3. RE-RENDER: the old code observed the button element itself. Apps that
 *    replace the button on click detached that node, so no mutations ever
 *    fired and the 1200ms fallback reported a wrong "add". We now observe
 *    the surrounding container with subtree:true and re-query the button on
 *    every mutation, so replacement is handled.
 *
 * 4. BROKEN IMAGE: img.src = '' made the browser request the current page
 *    URL and render a broken-image icon. The image is now hidden instead.
 *
 * 5. GUARDS: e.target may not be an Element (TypeError on .closest), and
 *    className on an SVG node is an SVGAnimatedString, not a string.
 *
 * 6. PERFORMANCE: product JSON is cached, so repeated clicks on the same
 *    product don't re-fetch. In-flight requests are de-duplicated too.
 *
 * 7. ACCESSIBILITY: the toast now uses role="status" + aria-live="polite"
 *    so screen readers announce it. Respects prefers-reduced-motion.
 *
 * 8. STACKING: a new click cancels the previous pending watcher, so two
 *    fast clicks can't produce two conflicting toasts.
 *
 * Usage:
 * 1) Save in your theme's assets folder as wishlist-toast.js
 * 2) In theme.liquid, right before </body>:
 *    <script src="{{ 'wishlist-toast.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
   * CONFIG — adjust this to match your wishlist app's markup.
   * Add whatever selector your wishlist button actually uses.
   * ------------------------------------------------------------------- */
  var WISHLIST_SELECTOR = [
    '[data-wishlist-button]',
    '[data-wishlist]',
    '.wishlist-button',
    '.wishlist-btn',
    '.js-wishlist',
    '.wk-button',            // common app prefixes
    '.swym-button',
    '[class*="wishlist"]'    // broad fallback — remove if it over-matches
  ].join(',');

  var CARD_SELECTOR = '[data-product-handle]';
  var TOAST_MS = 3000;
  var DETECT_TIMEOUT_MS = 2500;   // was 1200 — slow apps were being cut off

  var hideTimer = null;
  var activeWatcher = null;       // cancels a previous pending watcher
  var productCache = Object.create(null);

  /* ---------------------------------------------------------------------
   * I18N — matches the store's Published languages (Settings > Languages).
   * Add / edit entries here if you publish more languages later.
   * ------------------------------------------------------------------- */
  var I18N = {
    en: { added: 'Added to wishlist', removed: 'Removed from wishlist' },
    es: { added: 'A\u00f1adido a la lista de deseos', removed: 'Eliminado de la lista de deseos' },
    de: { added: 'Zur Wunschliste hinzugef\u00fcgt', removed: 'Von der Wunschliste entfernt' },
    pt: { added: 'Adicionado \u00e0 lista de desejos', removed: 'Removido da lista de desejos' }, // Portuguese (Portugal)
    fr: { added: 'Ajout\u00e9 \u00e0 la liste de souhaits', removed: 'Retir\u00e9 de la liste de souhaits' },
    it: { added: 'Aggiunto alla lista dei desideri', removed: 'Rimosso dalla lista dei desideri' }
  };
  var DEFAULT_LOCALE = 'en';

  /**
   * Detects the storefront's current language.
   * Priority: <html lang="..."> (Shopify sets this per-locale on every
   * storefront page) -> window.Shopify.locale -> DEFAULT_LOCALE.
   * "pt-PT", "fr-FR", etc. are normalized down to the base "pt", "fr".
   */
  function getLocale() {
    var raw =
      (document.documentElement && document.documentElement.lang) ||
      (window.Shopify && window.Shopify.locale) ||
      DEFAULT_LOCALE;
    raw = String(raw).toLowerCase().split('-')[0].split('_')[0];
    return I18N[raw] ? raw : DEFAULT_LOCALE;
  }

  function t(key) {
    var locale = getLocale();
    return (I18N[locale] && I18N[locale][key]) || I18N[DEFAULT_LOCALE][key];
  }

  /* ---------------------------------------------------------------------
   * DOM helpers
   * ------------------------------------------------------------------- */

  // SVG elements return an SVGAnimatedString from .className, not a string.
  function classString(el) {
    if (!el) return '';
    var c = el.className;
    if (c && typeof c === 'object' && 'baseVal' in c) return c.baseVal;
    return typeof c === 'string' ? c : '';
  }

  function labelString(el) {
    if (!el) return '';
    return (
      (el.getAttribute('aria-label') || '') + ' ' +
      (el.getAttribute('title') || '') + ' ' +
      (el.textContent || '')
    );
  }

  /**
   * Best-effort guess at "is this product currently in the wishlist?"
   * Checked in order of reliability.
   */
  function isInWishlist(button, card) {
    // 1. aria-pressed is the most reliable signal when present.
    var pressed = (button.getAttribute('aria-pressed') || '').toLowerCase();
    if (pressed === 'true') return true;
    if (pressed === 'false') return false;

    // 2. State classes on the button or the card.
    var cls = (classString(button) + ' ' + classString(card)).toLowerCase();
    if (/(^|[\s_-])(is-)?(active|added|selected|checked|filled|liked|wishlisted|in-wishlist)([\s_-]|$)/.test(cls)) {
      return true;
    }

    // 3. Visible label text. Only trusted as a last resort, because some
    //    apps keep BOTH labels in the DOM and just toggle visibility.
    var visibleText = '';
    var nodes = button.querySelectorAll('*');
    if (nodes.length) {
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetParent === null && n.getAttribute('aria-hidden') !== 'false') continue;
        visibleText += ' ' + (n.getAttribute('aria-label') || '') + ' ' + (n.textContent || '');
      }
    }
    if (!visibleText.trim()) visibleText = labelString(button);

    return /remove|added|saved|in\s*wishlist/i.test(visibleText);
  }

  /* ---------------------------------------------------------------------
   * Toast UI
   * ------------------------------------------------------------------- */

  function createToast() {
    var existing = document.getElementById('wishlist-toast');
    if (existing) return existing;

    var style = document.createElement('style');
    style.id = 'wishlist-toast-styles';
    style.textContent =
      '#wishlist-toast{position:fixed;top:240px;right:24px;display:flex;' +
      'align-items:center;gap:12px;background:#fff;color:#111;border-radius:10px;' +
      'box-shadow:0 8px 24px rgba(0,0,0,0.15);padding:12px 16px;max-width:320px;' +
      'z-index:99999;opacity:0;transform:translateY(20px);' +
      'transition:opacity .3s ease,transform .3s ease;pointer-events:none;font-family:inherit;}' +
      '#wishlist-toast.show{opacity:1;transform:translateY(0);}' +
      '#wishlist-toast img{width:48px;height:48px;object-fit:cover;border-radius:6px;flex-shrink:0;}' +
      '#wishlist-toast img[hidden]{display:none;}' +
      '#wishlist-toast .wt-text{display:flex;flex-direction:column;overflow:hidden;}' +
      '#wishlist-toast .wt-status{font-size:12px;font-weight:600;margin-bottom:2px;}' +
      '#wishlist-toast.wt-added .wt-status{color:#16a34a;}' +
      '#wishlist-toast.wt-removed .wt-status{color:#6b7280;}' +
      '#wishlist-toast .wt-title{font-size:13px;font-weight:500;white-space:nowrap;' +
      'overflow:hidden;text-overflow:ellipsis;}' +
      '#wishlist-toast .wt-price{font-size:12px;color:#666;}' +
      '@media (prefers-reduced-motion: reduce){' +
      '#wishlist-toast{transition:opacity .01ms;transform:none;}' +
      '#wishlist-toast.show{transform:none;}}';
    document.head.appendChild(style);

    var toast = document.createElement('div');
    toast.id = 'wishlist-toast';
    // a11y: announce without stealing focus
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<img id="wt-img" src="" alt="" hidden>' +
      '<div class="wt-text">' +
      '<span class="wt-status" id="wt-status"></span>' +
      '<span class="wt-title" id="wt-title"></span>' +
      '<span class="wt-price" id="wt-price"></span>' +
      '</div>';
    document.body.appendChild(toast);
    return toast;
  }

  function formatMoney(cents) {
    cents = cents || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify && window.Shopify.money_format) ||
        null;
      if (fmt) {
        try {
          return window.Shopify.formatMoney(cents, fmt);
        } catch (e) { /* fall through to manual format */ }
      }
    }
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return (currency ? currency + ' ' : '') + (cents / 100).toFixed(2);
  }

  function showToast(product, variant, action) {
    var toast = createToast();
    var img = document.getElementById('wt-img');
    var title = document.getElementById('wt-title');
    var price = document.getElementById('wt-price');
    var status = document.getElementById('wt-status');

    var imageUrl =
      (variant && variant.featured_image && variant.featured_image.src) ||
      product.featured_image ||
      (product.images && product.images[0]) ||
      '';

    // FIX: never set src to '' — that requests the current page URL and
    // renders a broken-image icon. Hide the element instead.
    if (imageUrl) {
      img.src = imageUrl;
      img.alt = product.title || '';
      img.hidden = false;
    } else {
      img.removeAttribute('src');
      img.alt = '';
      img.hidden = true;
    }

    title.textContent = product.title || '';
    price.textContent = formatMoney(variant ? variant.price : product.price);

    toast.classList.remove('wt-added', 'wt-removed');
    if (action === 'remove') {
      status.textContent = '\u2717 ' + t('removed');
      toast.classList.add('wt-removed');
    } else {
      status.textContent = '\u2713 ' + t('added');
      toast.classList.add('wt-added');
    }

    clearTimeout(hideTimer);
    // Force a reflow so the transition replays if the toast is already shown.
    void toast.offsetWidth;
    toast.classList.add('show');
    hideTimer = setTimeout(function () {
      toast.classList.remove('show');
    }, TOAST_MS);
  }

  /* ---------------------------------------------------------------------
   * Product data (cached + de-duplicated)
   * ------------------------------------------------------------------- */

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];

    var promise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status + ' for ' + handle);
        return res.json();
      })
      .catch(function (err) {
        // Don't cache failures — allow a retry on the next click.
        delete productCache[handle];
        throw err;
      });

    productCache[handle] = promise;
    return promise;
  }

  /* ---------------------------------------------------------------------
   * Toggle watcher
   * ------------------------------------------------------------------- */

  /**
   * Watches the CARD (not the button) so that apps which replace the button
   * element on click are still detected. Re-queries the button each time.
   */
  function watchForToggle(card, buttonSelector, wasInWishlist, callback) {
    var done = false;
    var observer = null;
    var timeoutId = null;

    function finish(action) {
      if (done) return;
      done = true;
      if (observer) observer.disconnect();
      clearTimeout(timeoutId);
      if (activeWatcher === handle) activeWatcher = null;
      callback(action);
    }

    var handle = {
      cancel: function () {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();
        clearTimeout(timeoutId);
      }
    };

    observer = new MutationObserver(function () {
      if (done) return;

      // Re-query: the original button may have been replaced entirely.
      var current = card.querySelector(buttonSelector) || card;
      var nowInWishlist = isInWishlist(current, card);

      if (nowInWishlist === wasInWishlist) return;   // no state change yet
      finish(nowInWishlist ? 'add' : 'remove');
    });

    observer.observe(card, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    timeoutId = setTimeout(function () {
      // Couldn't detect a change in time. Assume the opposite of the
      // previous state — that's the likely outcome of a toggle click, and
      // it's a better guess than always saying "add".
      finish(wasInWishlist ? 'remove' : 'add');
    }, DETECT_TIMEOUT_MS);

    return handle;
  }

  /* ---------------------------------------------------------------------
   * Click handler (capture phase — runs before the app's own handler)
   * ------------------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    // FIX: e.target isn't guaranteed to be an Element.
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    // FIX (main bug): require an actual wishlist trigger, not just any
    // click inside the product card.
    var button = target.closest(WISHLIST_SELECTOR);
    if (!button) return;

    var card = button.closest(CARD_SELECTOR) || target.closest(CARD_SELECTOR);
    if (!card) return;

    var handleAttr = card.getAttribute('data-product-handle') ||
                     button.getAttribute('data-product-handle');
    if (!handleAttr) return;

    var variantId = card.getAttribute('data-variant-id') ||
                    button.getAttribute('data-variant-id');

    // Cancel any watcher still pending from a previous fast click.
    if (activeWatcher) activeWatcher.cancel();

    var wasInWishlist = isInWishlist(button, card);

    activeWatcher = watchForToggle(card, WISHLIST_SELECTOR, wasInWishlist, function (action) {
      getProduct(handleAttr)
        .then(function (product) {
          var variant = null;
          if (variantId && product.variants) {
            for (var i = 0; i < product.variants.length; i++) {
              if (String(product.variants[i].id) === String(variantId)) {
                variant = product.variants[i];
                break;
              }
            }
          }
          if (!variant && product.variants && product.variants.length) {
            variant = product.variants[0];
          }
          showToast(product, variant, action);
        })
        .catch(function (err) {
          console.error('[wishlist-toast] product fetch failed:', err);
        });
    });
  }, true);
})();